const { getElements } = window.BAO.Utils

class PauseVideo extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.checkIfShouldPause()
    this.toggleIcons()
  }

  setupListeners () {
    super.setupListeners()

    this.toggleVideos = this.toggleVideos.bind(this)

    if (this?.els?.trigger?.exists) {
      this.listeners.add(this.els.trigger.element, 'click', this.toggleVideos)
    }
  }

  toggleVideos () {
    if (this.isPaused) {
      // Currently paused → play videos
      window.sessionStorage.removeItem('pauseVideo')

      if (this?.els?.text?.exists && this?.els?.trigger?.exists) {
        this.els.text.element.innerHTML =
          this.els.trigger.element.dataset.pauseText
      }

      this.playAllVideos()
    } else {
      // Currently playing → pause videos
      window.sessionStorage.setItem('pauseVideo', 'true')

      if (this?.els?.text?.exists && this?.els?.trigger?.exists) {
        this.els.text.element.innerHTML =
          this.els.trigger.element.dataset.playText
      }

      this.pauseAllVideos()
    }

    this.toggleIcons()
  }

  toggleIcons () {
    if (this?.els?.pause?.exists) {
      this.els.pause.element.setAttribute('aria-hidden', String(this.isPaused))
    }
    if (this?.els?.play?.exists) {
      this.els.play.element.setAttribute('aria-hidden', String(!this.isPaused))
    }
  }

  checkIfShouldPause () {
    if (this.isPaused) {
      if (this?.els?.text?.exists && this?.els?.trigger?.exists) {
        this.els.text.element.innerHTML =
          this.els.trigger.element.dataset.playText
      }
      this.pauseAllVideos()
    }
  }

  playAllVideos () {
    const lazyVideos = getElements('lazy-video')

    lazyVideos.forEach((lazyEl) => {
      const video = lazyEl.querySelector('video')
      if (!video) return

      // Only restore autoplay for videos that had it originally
      if (video.hasAttribute('data-was-autoplay')) {
        video.setAttribute('autoplay', '')
        video.setAttribute('muted', '')
        video.setAttribute('playsinline', '')

        video.play().catch((err) => {
          console.warn('Video failed to play:', err)
        })
      }
    })
  }

  pauseAllVideos () {
    const lazyVideos = getElements('lazy-video')

    lazyVideos.forEach((lazyEl) => {
      const video = lazyEl.querySelector('video')
      if (!video) return

      // Remember if it was originally autoplay
      if (
        video.hasAttribute('autoplay') &&
        !video.hasAttribute('data-was-autoplay')
      ) {
        video.setAttribute('data-was-autoplay', 'true')
      }

      video.pause()
      video.removeAttribute('autoplay')
      video.removeAttribute('muted')
      video.removeAttribute('playsinline')
    })
  }

  get isPaused () {
    return window.sessionStorage.getItem('pauseVideo') === 'true'
  }
}

if (!customElements.get('pause-video')) {
  customElements.define('pause-video', PauseVideo)
}
